import { ParseResult, Schema as S } from "effect";
export const Schema = S.String.pipe(S.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/), S.brand("@open-revenue/schema/Email"));
export const FromString = S.transformOrFail(S.String, S.NullOr(Schema), {
    decode: (s, _, ast)=>{
        const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(s);
        return isValid ? ParseResult.succeed(s) : ParseResult.succeed(null);
    },
    encode: (value)=>ParseResult.succeed(value ?? "")
});
export const Type = Schema.Type;
export const make = (id)=>S.decode(Schema)(id);
export const makeUnsafe = (id)=>id;
